/**
* PURPOSE: Servicios HTTP para administración de usuarios.
* RESPONSIBILITIES: Listar, obtener, crear, actualizar y eliminar lógicamente usuarios desde Winscore.
* COLLABORATORS: src/sections/UserSection.jsx, src/admin/CreateUser/Modal/ModalCreateUser/ModalCreateUser.jsx, src/admin/CreateUser/Modal/ModalEditUser/ModalEditUser.jsx
* ROUTE: src/services/user.js
*/
import httpService from "./httpService.js";

export async function getUsers() {
  return httpService.get("/users").then((response) => {
    const data = response?.data;
    return Array.isArray(data) ? data : [];
  });
}

export async function getUser(iduser) {
  return httpService.get(`/users/${iduser}`).then((response) => response?.data || null);
}

export async function createUser(payload) {
  return httpService.post("/users", payload).then((response) => response?.data);
}

export async function updateUser(iduser, payload) {
  return httpService.patch(`/users/${iduser}`, payload).then((response) => response?.data);
}

export async function deleteUser(iduser) {
  return httpService.delete(`/users/${iduser}`).then((response) => response?.data);
}
